<div class="max-w-4xl mx-auto mt-10 bg-white rounded-xl shadow p-6">
    <h2 class="text-2xl font-semibold text-center text-indigo-700 mb-4">📱 Liste des Devices</h2>

    <!-- Loader si isLoading est true -->
    <div *ngIf="loading" class="fixed inset-0 flex items-center justify-center bg-white z-50">
        <mat-spinner diameter="50"></mat-spinner>
    </div>
    <div *ngIf="!loading">
        <table class="w-full text-left border border-gray-300">
            <thead class="bg-indigo-100">
                <tr>
                    <th class="p-2 text-center">Device UUID</th>
                    <th class="p-2 text-center">Point de vente</th>
                    <th class="p-2 text-center">Name</th>
                    <th class="p-2 text-center">Actif</th>
                    <th class="p-2 text-center">Affectation</th>
                    <th class="p-2 text-center">Configuration</th>
                    <th class="p-2 text-center">Default</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let device of devices">
                    <td class="p-2 border-t border-gray-300 text-center">{{ device.uuid }}</td>
                    <td class="p-2 border-t border-gray-300 text-center">{{ device.denomination_pos || '-' }}</td>
                    <td class="p-2 border-t border-gray-300 text-center">{{ device.n_location || '-' }}</td>
                    <td *ngIf="device.archive === 0" class="p-2 border-t border-gray-300 text-center">✅</td>
                    <td *ngIf="device.archive === 1" class="p-2 border-t border-gray-300 text-center">🔄</td>
                    <td *ngIf="device.archive === 2" class="p-2 border-t border-gray-300 text-center">❌</td>
                    <td class="p-2 border-t border-gray-300 text-center">
                        <button [routerLink]="['/deviceAssignation']"
                            [queryParams]="{ deviceId: device.uuid, deviceName: device.n_location, devicePoS: device.denomination_pos, id_user: id_user}"
                            class="bg-blue-500 hover:bg-blue-600 text-white text-sm font-semibold py-1 px-3 rounded">
                            🔗 Affectation
                        </button>
                    </td>
                    <td class="p-2 border-t border-gray-300 text-center">
                        <button [routerLink]="['/changeImageMCConnectTable']" [queryParams]="{ deviceId: device.uuid }"
                            class="bg-blue-500 hover:bg-blue-600 text-white text-sm font-semibold py-1 px-3 rounded">
                            🔗 Configurer
                        </button>
                    </td>
                    <td class="p-2 border-t border-gray-300 text-center">
                        <button (click)="defaultQRencode(device.n_location, device.uuid, id_user)"
                            class="bg-blue-500 hover:bg-blue-600 text-white text-sm font-semibold py-1 px-3 rounded">
                            🔗 Defaut
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

    <button (click)="syncDevices()" class="mb-4 bg-green-600 hover:bg-green-700 text-white font-bold py-2 px-4 rounded">
        🔄 Synchroniser les devices
    </button>

    <div *ngIf="errorMessage" class="mt-4 text-red-500 text-center">
        ❌ {{ errorMessage }}
    </div>
</div>